const CANCELLED = ["cancelled", "cancelled_late", "burned", "rejected"];
const APPROVED = ["approved", "confirmed", "approved_by_member"];

export const resColorGroup = (status) => {
  if (CANCELLED.includes(status)) return "cancelled";
  if (APPROVED.includes(status)) return "approved";
  if (status === "completed") return "completed";
  return "pending";
};

export const RES_COLORS = {
  approved: { label: "Onaylı", card: "bg-green-100 text-green-800 border-green-300", dot: "bg-green-500" },
  completed: { label: "Tamamlandı", card: "bg-blue-100 text-blue-800 border-blue-300", dot: "bg-blue-500" },
  pending: { label: "Onay bekliyor", card: "bg-orange-100 text-orange-800 border-orange-300", dot: "bg-orange-500" },
  cancelled: { label: "İptal / Yakıldı", card: "bg-red-50 text-red-400 border-red-200 opacity-80", dot: "bg-red-400" },
};

export const resColorClass = (status) => RES_COLORS[resColorGroup(status)].card;

export const ReservationColorLegend = () => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 px-3 py-2 border-t text-[11px] text-slate-600" data-testid="reservation-color-legend">
    {Object.entries(RES_COLORS).map(([k, c]) => (
      <span key={k} className="inline-flex items-center gap-1.5">
        <span className={`w-2.5 h-2.5 rounded-sm ${c.dot}`} />
        <span className={k === "cancelled" ? "line-through" : ""}>{c.label}</span>
      </span>
    ))}
    <span className="inline-flex items-center gap-1.5">
      <span className="rounded px-1 text-[9px] font-bold leading-4 bg-sky-500 text-white">Online</span>
      Online ders programında
    </span>
  </div>
);

export const MonthDayCounts = ({ reservations }) => {
  const counts = reservations.reduce((acc, r) => ({ ...acc, [resColorGroup(r.status)]: (acc[resColorGroup(r.status)] || 0) + 1 }), {});
  return (
    <div className="mt-0.5 sm:mt-1 flex flex-wrap gap-0.5">
      {Object.keys(RES_COLORS).filter((k) => counts[k]).map((k) => (
        <span key={k} className={`inline-flex items-center justify-center min-w-[16px] rounded px-1 text-[9px] sm:text-[10px] font-bold text-white ${RES_COLORS[k].dot}`} title={RES_COLORS[k].label}>
          {counts[k]}
        </span>
      ))}
    </div>
  );
};
